import { ReactNode } from 'react'

import Tooltip from '~/components/Tooltip'
import useTooltipToggle from '~/shared/hooks/useTooltipToggle.hook'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import QuestionCirclePurpleIcon from '~/components/Icons/svgs/QuestionCirclePurpleIcon'
import QuestionCircleWhiteIcon from '~/components/Icons/svgs/QuestionCircleWhiteIcon'
import { ArrowPosition } from '~/components/Tooltip/Tooltip.types'

export default function QuestionIconWithTooltip({
  children,
  iconColor = 'purple',
  className = '',
  arrowPosition = 'bottom-right',
}: {
  children: ReactNode
  className?: string
  iconColor?: 'white' | 'purple'
  arrowPosition?: ArrowPosition
}): React.ReactElement {
  const { showTooltip, handleOnClick, handleOnMouseEnter, handleOnMouseLeave } = useTooltipToggle()

  const icon = iconColor === 'white' ? QuestionCircleWhiteIcon : QuestionCirclePurpleIcon

  return (
    <span className={`cursor-help ${className}`}>
      <Tooltip arrowPosition={arrowPosition} showTooltip={showTooltip}>
        {children}
      </Tooltip>
      <span onClick={handleOnClick} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
        <SVGIcon icon={icon} size={24} />
      </span>
    </span>
  )
}
